import { useState, SyntheticEvent } from 'react'
import { payment } from '../../interfaces'
import detailFunction from '../crudFunctions/detailFunction'
import PayDetailModal from './PayDetailModal'

interface props {
  setShowPaySearchModal: React.Dispatch<React.SetStateAction<boolean>>
  setShowDetailModal: React.Dispatch<React.SetStateAction<boolean>>
  showDetailModal: boolean
  setSinglePayment: React.Dispatch<React.SetStateAction<null | payment>>
  singlePayment: null | payment
}

const PaySearchModal = ({
  setShowPaySearchModal,
  setShowDetailModal,
  showDetailModal,
  setSinglePayment,
  singlePayment
}: props) => {
  const [query, setQuery] = useState<string>('')
  const [isError, setIsError] = useState<boolean>(false)
  const [searchMethod, setSearchMethod] = useState<string>('Referencia')
  const [paymentResult, setPaymentResult] = useState<payment[]>([])

  const handleSearch = (e: SyntheticEvent): void => {
    e.preventDefault()
    if (searchMethod === 'Referencia') {
      const endpoint: string = `payment/search/number/${query}`
      detailFunction(endpoint).then((response: payment[]) => {
        if (response) {
          setPaymentResult(response)
          setIsError(false)
        } else {
          setPaymentResult([])
          setIsError(true)
        }
      })
    } else if (searchMethod === 'Nombre') {
      const endpoint: string = `payment/search/client/${query}`
      detailFunction(endpoint).then((response: payment[]) => {
        if (response) {
          setPaymentResult(response)
          setIsError(false)
        } else {
          setPaymentResult([])
          setIsError(true)
        }
      })
    } else {
      const endpoint: string = `payment/search/phone/${query}`
      detailFunction(endpoint).then((response: payment[]) => {
        if (response) {
          setPaymentResult(response)
          setIsError(false)
        } else {
          setPaymentResult([])
          setIsError(true)
        }
      })
    }
  }
  return (
    <>
      {showDetailModal && (
        <PayDetailModal
          setShowDetailModal={setShowDetailModal}
          singlePayment={singlePayment}
        />
      )}
      <div id='searchPaymentModal' className='modal'>
        <div className='modal-content grid justify-items-center rounded-md'>
          <form className='grid' onSubmit={handleSearch}>
            <label htmlFor='method'>Buscar por:</label>
            <select
              name='method'
              id='method'
              defaultValue={'Referencia'}
              className='border-2 border-black rounded-md text-center mb-5'
              onChange={(e) => setSearchMethod(e.target.value)}>
              <option value='Referencia'>Referencia</option>
              <option value='Nombre'>Nombre</option>
              <option value='Telefono'>Telefono</option>
            </select>
            <label htmlFor='query' className='text-lg'>
              {searchMethod}:
            </label>
            <input
              type='text'
              name='query'
              id='query'
              className='border-2 border-black rounded-md text-center mb-5'
              onChange={(e) => setQuery(e.target.value)}
            />

            <button
              type='submit'
              className='bg-viper  text-white text-xl rounded-lg w-3/4 place-self-center px-8 py-2 mb-5 shadow-lg'>
              <span>Buscar</span>
            </button>
            {paymentResult && (
              <table className='table-fixed w-full mx-auto text-xl'>
                <tbody>
                  <tr>
                    <th className='border-2 text-center'>Cliente</th>
                    <th className='border-2 text-center'>Teléfono</th>
                    <th className='border-2 text-center'>Fecha</th>
                    <th className='border-2 text-center'>Detalle</th>
                  </tr>
                  {paymentResult.map((payment: payment) => {
                    return (
                      <tr key={payment.id}>
                        <td className='border-2 text-center'>
                          {payment.client_name}
                        </td>
                        <td className='border-2 text-center'>
                          {payment.client_phone}
                        </td>
                        <td className='border-2 text-center'>{payment.date}</td>
                        <td className='border-2 text-center'>
                          <button
                            className='text-blue-400'
                            onClick={() => {
                              setSinglePayment(payment)
                              setShowDetailModal(true)
                            }}>
                            Ver Detalle
                          </button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            )}

            {isError && (
              <p className='text-center text-lg mt-5'>No existe ese pago</p>
            )}
          </form>
          <button
            className='bg-red-400  text-white text-xl rounded-lg px-8 py-2 mt-10 shadow-lg'
            onClick={() => {
              setShowPaySearchModal(false)
              setPaymentResult([])
            }}>
            <span>Cerrar</span>
          </button>
        </div>
      </div>
    </>
  )
}

export default PaySearchModal
